import React from 'react';
import { Steps } from 'antd';

const { Step } = Steps;

const ListSteps: React.FC<any> = ({ record }) => {
  const customDot = (dot: React.ReactNode) => <>{dot}</>;
  let activeStep;
  switch (record.status) {
    case 'AGE':
      activeStep = 0;
      break;
    case 'EXP':
      activeStep = 1;
      break;
    default:
      activeStep = undefined;
      break;
  }

  return (
    <>
      <Steps className="steps" responsive={true} current={activeStep} progressDot={customDot}>
        <Step title="Agendado" description="" />
        <Step title="Expedido" description="" />
      </Steps>
      <span>
        {activeStep !== undefined && activeStep > 2 ? (
          <strong>Para cancelamentos, entre em contato com o CD</strong>
        ) : (
          ''
        )}
      </span>
    </>
  );
};

export default ListSteps;
